"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _KeyboardArrowDown = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowDown"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/*
 * Description: This component gives you a group of buttons
 * Props: 
 * - children: Children that will be shown to the user
 * - title: The title of the dropdown button
 * - items: Array of items to be shown in the dropdown
 * - variant: The variant of the button (e.g., primary, secondary, etc.)
 * - button: Boolean indicating if the dropdown should be a button group
 * - onSelect: Function to call when an item is selected
 * - onClick: Function to call when the button is clicked
 */

const DmsDropdown = _ref => {
  let {
    title,
    items,
    variant = "contained",
    button = false,
    onSelect = () => {},
    onClick = () => {}
  } = _ref;
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const buttonVariant = variant === "primary" ? "contained" : variant;
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    onClick();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = item => {
    onSelect(item);
    handleClose();
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: buttonVariant,
    endIcon: /*#__PURE__*/_react.default.createElement(_KeyboardArrowDown.default, null),
    onClick: handleClick
  }, title), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    id: "simple-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, items.map((item, index) => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    key: index,
    onClick: () => handleSelect(item)
  }, item))));
};
exports.DmsDropdown = DmsDropdown;